import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
    controlAreas: [],
    suggestions: ['Injicering']
}


export default (state = initState, action) => {
    switch (action.type) {
        case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
            return update(state, {
                controlAreas: {
                    $set: action.controlAreas
                }
            });
        case actionConsts.UPDATE_CONTROL_AREA:
            return update(state, {
                controlAreas: {
                    [action.index]: {
                        [action.typeOf]: {
                            $set: action.value
                        }
                    }
                }
            });
        case actionConsts.ADD_CONTROL_AREA:
            return update(state, {
                controlAreas: {
                    $push: [action.controlArea]
                }
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/ControlArea/reducer.js